import { useContext } from 'react';
import { ConnectivityContext, ConnectivityContextValue } from './ConnectivityContext';

export function useConnectivity(): ConnectivityContextValue {
  const context = useContext(ConnectivityContext);

  if (!context) {
    throw new Error('useConnectivity must be used within a ConnectivityProvider');
  }

  return context;
}
